
import { List, Item } from '@components/productDetail/PageFooter.jsx';

import LinkPopup from '@components/popups/Link';
import * as AppraisalContent from '@components/popups/content/LumeraAppraisal';
import * as PackagingContent from '@components/popups/content/SecurePackagingShipping';
import * as ReturnPolicyContent from '@components/popups/content/ReturnPolicy';

const AppraisalIcon = '/images/benefit_icons/appraisal.png';
const ShippingIcon = '/images/benefit_icons/overnight_shipping.png';
const InsuranceIcon = '/images/benefit_icons/secure_delivery.png';
const ReturnIcon = '/images/benefit_icons/return_policy.png';

function EveryPurchase () {
  return (
    <section style={{ position: 'relative' }}>
      <h2 className="blue-text" style={{ marginBottom: 20 }}>
        Every purchase includes:
      </h2>
      <List>
        <Item icon={AppraisalIcon} iconStyles={{ height: 16, width: 14 }}>
          <strong>Free</strong>{' '}
          <LinkPopup initialContent={AppraisalContent}>Appraisal</LinkPopup>
        </Item>
        <Item icon={ShippingIcon} iconStyles={{ height: 15, width: 15 }}>
          <strong>Free FedEx Shipping</strong>
          <br />
          <LinkPopup initialContent={PackagingContent}>
            Discrete packaging
          </LinkPopup>
        </Item>
        <Item
          icon={InsuranceIcon}
          iconStyles={{
            height: 16,
            width: 12
          }}>
          <strong>Insured, Secure Delivery,</strong> so there is{' '}
          <LinkPopup initialContent={PackagingContent}>
            no risk to you
          </LinkPopup>
        </Item>
        <Item
          icon={ReturnIcon}
          iconStyles={{
            height: 15,
            width: 15
          }}>
          <strong>30-day</strong>{' '}
          <LinkPopup initialContent={ReturnPolicyContent}>
            return policy
          </LinkPopup>
        </Item>
      </List>
    </section>
  );
}

export default EveryPurchase;
